import { forwardRef, memo, useCallback, useState } from "react";
import classNames from "classnames";
import { Button, ButtonProps } from "../Button";
import { Loader } from "../Loaders";

import styles from "./style.module.scss";

export type ProgressButtonProps = ButtonProps & {
  processing?: boolean
}

export const ProgressButton = memo<ProgressButtonProps>(forwardRef<HTMLButtonElement, ProgressButtonProps>((
  {
    children,
    onClick,
    className,
    disabled,
    processing: externalProcessing,
    ...props
  }, ref) => {
  const [ processing, setProcessing ] = useState(false);

  const isProcessing = processing || externalProcessing;

  return (
    <Button
      {...props}
      ref={ref}
      className={classNames(styles.button, className, { [styles.processing]: isProcessing })}
      disabled={isProcessing || disabled}
      onClick={useCallback(async (e: any) => {
        try {
          setProcessing(true);
          await onClick?.(e);
        } finally {
          setProcessing(false);
        }
      }, [ setProcessing, onClick ])}
    >
      {isProcessing && <Loader className={styles.loader} />}
      {typeof children === "string" ? <span>{children}</span> : children}
    </Button>
  );
}));

export default ProgressButton;
